import { helperServices } from "../../shared/helper";
import history from "../../shared/utils/history";
import { apiFetch } from "../../shared/helper/apiFetch";

const basePath = "/api";

// -------------------- Logout --------------------
function logout() {
  localStorage.removeItem("user");
  history.push("/");
  window.location.reload();
}

// -------------------- Handle Response --------------------
function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    const token = response.headers.get("Authorization");

    if (token) {
      localStorage.setItem("token", JSON.stringify(token));
    }

    if (!response.ok) {
      if (response.status === 401) {
        logout();
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

// -------------------- Helper: Build Headers --------------------
function buildHeaders() {
  const accessToken = helperServices.getAuthorization() || "";
  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: accessToken,
  };
}

// -------------------- Get All Service Categories --------------------
function getAllServiceCategory() {
  const requestOptions = {
    method: "GET",
    headers: buildHeaders(),
  };

  const url = `${basePath}/master/category`;
  return apiFetch(url, requestOptions);
}

// -------------------- Add New Service --------------------
function addService(data) {
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };

  const url = `${basePath}/master/category`;
  return apiFetch(url, requestOptions);
}

// -------------------- Export --------------------
const categoryServices = {
  logout,
  handleResponse,
  getAllServiceCategory,
  addService,
};

export default categoryServices;
